
import makeStyles from '@mui/styles/makeStyles';
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import ApplicationBar, { toolbarHeight } from "../../Components/ApplicationBar";
import Footer from "../../Components/Footer";


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  content: {
    flexGrow: 1,
    overflow: "auto",
    marginTop: toolbarHeight,
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2),
  },
  mainPaper: {
    padding: theme.spacing(2),
    display: "flex",
    height: `calc(75vh)`,
    overflow: "auto",
    flexDirection: "column",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
}));


export default function MainLayout(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <ApplicationBar showProposalInfo/>
      <main className={classes.content}>
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Paper className={classes.mainPaper} style={{}}>
                {props.children}
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
